(() => {
  const cache = new Map();

  const getVariantOption = (variant, index) => {
    if (Array.isArray(variant.options)) {
      return variant.options[index];
    }
    return variant[`option${index + 1}`];
  };

  const getSelectedOptions = (variantSelects) => {
    return Array.from(variantSelects.querySelectorAll('fieldset')).map((fieldset) => {
      const select = fieldset.querySelector('select');
      if (select) {
        return select.value;
      }

      const checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  };

  const getVariants = (sectionId) => {
    if (cache.has(sectionId)) {
      return cache.get(sectionId);
    }

    const node = document.getElementById(`ProductVariants-${sectionId}`);
    if (!node) {
      cache.set(sectionId, []);
      return [];
    }

    let variants = [];
    try {
      variants = JSON.parse(node.textContent);
    } catch (error) {
      variants = [];
    }

    cache.set(sectionId, variants);
    return variants;
  };

  const formatDiff = (cents) => {
    const absValue = Math.abs(cents);
    if (typeof window.formatMoney === 'function' && window.theme?.settings?.money_with_currency_format) {
      const formatted = window.formatMoney(absValue, window.theme.settings.money_with_currency_format);
      return `${cents > 0 ? '+' : '-'}${formatted}`;
    }
    return `${cents > 0 ? '+' : '-'}${(absValue / 100).toFixed(2)}`;
  };

  const findVariantForValue = (variants, selectedOptions, optionIndex, value) => {
    return variants.find((variant) => {
      return selectedOptions.every((selected, index) => {
        if (index === optionIndex) {
          return getVariantOption(variant, index) === value;
        }
        return getVariantOption(variant, index) === selected;
      });
    });
  };

  const updateFieldset = (fieldset) => {
    const variantSelects = fieldset.closest('variant-selects');
    if (!variantSelects) {
      return;
    }

    const sectionId = variantSelects.dataset.section;
    const variants = getVariants(sectionId);
    if (!variants.length) {
      return;
    }

    const selectedOptions = getSelectedOptions(variantSelects);
    const optionIndex = parseInt(fieldset.dataset.optionPosition, 10) - 1;

    if (Number.isNaN(optionIndex)) {
      return;
    }

    const comparableVariants = variants.filter((variant) => {
      if (!variant.available) {
        return false;
      }

      return selectedOptions.every((selected, index) => {
        if (index === optionIndex) {
          return true;
        }
        return getVariantOption(variant, index) === selected;
      });
    });

    const baselinePrice = comparableVariants.length ? Math.min(...comparableVariants.map((variant) => variant.price)) : null;

    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      if (!label) {
        return;
      }

      const priceRow = label.querySelector('[data-clasp-price]');
      const compareNode = label.querySelector('[data-clasp-compare]');
      const currentNode = label.querySelector('[data-clasp-current]');
      const matchedVariant = findVariantForValue(variants, selectedOptions, optionIndex, input.value);
      const isSoldOut = !matchedVariant || !matchedVariant.available || input.dataset.available === 'false';

      label.classList.toggle('is-sold-out', isSoldOut);

      if (!priceRow || !compareNode || !currentNode) {
        return;
      }

      if (!matchedVariant || baselinePrice === null) {
        priceRow.hidden = true;
        compareNode.hidden = true;
        compareNode.textContent = '';
        currentNode.textContent = '';
        return;
      }

      const currentDiff = matchedVariant.price - baselinePrice;
      const compareDiff = matchedVariant.compare_at_price ? matchedVariant.compare_at_price - baselinePrice : null;

      if (currentDiff === 0) {
        priceRow.hidden = true;
        compareNode.hidden = true;
        compareNode.textContent = '';
        currentNode.textContent = '';
        return;
      }

      priceRow.hidden = false;
      currentNode.textContent = formatDiff(currentDiff);

      if (compareDiff && compareDiff !== currentDiff && matchedVariant.compare_at_price > matchedVariant.price) {
        compareNode.hidden = false;
        compareNode.textContent = formatDiff(compareDiff);
      } else {
        compareNode.hidden = true;
        compareNode.textContent = '';
      }
    });
  };

  const updateSection = (sectionId) => {
    document.querySelectorAll(`variant-selects[data-section="${sectionId}"] [data-clasp-card-picker]`).forEach(updateFieldset);
  };

  const init = () => {
    document.querySelectorAll('[data-clasp-card-picker]').forEach(updateFieldset);
  };

  document.addEventListener('product:variant-change', (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) {
      return;
    }
    updateSection(sectionId);
  });

  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
})();
